/* istanbul ignore file */
import styled from 'styled-components';
import { Colors } from '../../../theme';
import { getSpacing, Spacing } from '../../../utils';

export const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const TableContainer = styled.div<{
  columnBackgroundColor: Colors | undefined;
  rowHoverColor: Colors | undefined;
  selectedRowColor: Colors | undefined;
  useZebraStyles: boolean;
  isRowSelectable: boolean;
  noBorder?: boolean;
  fixedHeight?: string;
  stickyFirstColumn?: boolean;
  stickyLastColumn?: boolean;
  firstCellMinWidth?: string | Spacing;
}>`
  height: ${({ fixedHeight }) => fixedHeight && fixedHeight};
  flex: ${({ fixedHeight }) => (fixedHeight ? 'none' : '1')};
  overflow: auto;

  th {
    background-color: ${({ columnBackgroundColor, theme: { color } }) =>
      columnBackgroundColor && color[columnBackgroundColor]};
    border-bottom: ${({ noBorder }) => noBorder && 'none'};
  }

  tbody {
    tr {
      cursor: ${({ isRowSelectable }) => (isRowSelectable ? 'pointer' : 'inherit')};
      background-color: ${({ theme: { color, palette } }) =>
        palette.mode === 'dark' ? color.backgroundPaperDark : color.white};

      &:nth-of-type(2n) {
        background-color: ${({ theme: { color, palette }, useZebraStyles }) => {
          return useZebraStyles && (palette.mode === 'dark' ? color.backgroundPaperDark : color.baseGray);
        }};
      }

      &.MuiTableRow-root.MuiTableRow-hover:hover,
      &.MuiTableRow-root.MuiTableRow-hover.highlightedRow {
        background-color: ${({ rowHoverColor, theme: { color } }) => rowHoverColor && color[rowHoverColor]};
      }

      &.MuiTableRow-root.Mui-selected {
        background-color: ${({ selectedRowColor, theme: { color } }) =>
          selectedRowColor && color[selectedRowColor]};
      }
    }
    td {
      &.MuiTableCell-root {
        border-bottom: ${({ theme: { color, palette }, noBorder }) =>
          noBorder ? 'none' : `1px solid ${palette.mode === 'dark' ? color.borderGrayDark : color.borderGray}`};
      }
    }
  }
  ${({ firstCellMinWidth, theme: { spacing } }) =>
    firstCellMinWidth &&
    `
    thead > tr > th:first-of-type,
    tbody > tr > td:first-of-type,
    tfoot > tr > td:first-of-type {
      min-width: ${
        typeof firstCellMinWidth === 'string'
          ? firstCellMinWidth
          : firstCellMinWidth && getSpacing(firstCellMinWidth, spacing)
      };
    }
  `}
  ${({ stickyFirstColumn, theme: { palette, color } }) =>
    stickyFirstColumn &&
    `
    thead > tr > th:first-of-type {
      position: sticky;
      left: 0;
      z-index: 4;
      border-right: 1px solid
        ${palette.mode === 'dark' ? color.borderGrayDark : color.borderGray};
      background-color: ${palette.mode === 'dark' ? color.backgroundTableHeaderDark : color.backgroundTableHeader};
    }
        
    tbody > tr > td:first-of-type,
    tfoot > tr > td:first-of-type {
      position: sticky;
      left: 0;
        border-right: 1px solid
          ${palette.mode === 'dark' ? color.borderGrayDark : color.borderGray};
      background-color: ${palette.mode === 'dark' ? color.backgroundTableHeaderDark : color.backgroundTableHeader};
    }
  `}
  ${({ stickyLastColumn, theme: { palette, color } }) =>
    stickyLastColumn &&
    `
    thead > tr > th:last-child,
    tbody > tr > td:last-child,
    tfoot > tr > td:first-of-type {
      position: sticky;
      right: 0;
      background-color: ${palette.mode === 'dark' ? color.backgroundTableHeaderDark : color.backgroundTableHeader};
    }
  `}
`;

export const PaginatorContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
